import React from 'react'
import LoginComponent from '../../components/loginComponent/LoginComponent';



function Login() {
    return (
        <div>
            <LoginComponent /> 
        </div>
    )
}

export default Login